module.exports = __webpack_public_path__ + "4396f4750c887c9c88cc6f0823c6ea3c.pdf";